<!-- =========================================================================================
  File Name: CompanyEditGeneralDetails.vue
  Description: Entity Edit account content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-branding-form" :class="readonly ? 'readonly-form' : ''">
    <card-page card-title="Entity Branding">
      <vue-element-loading :active="busy"></vue-element-loading>
      <div class="logo-form-wrapper">
        <vue-form-generator
          v-if="!readonly"
          class="mt-4"
          ref="form"
          :model="model"
          :options="formOptions"
          :schema="schema"
        />
        <vs-button
          class="m-4"
          color="primary"
          @click="popupActive=true"
          :disabled="!currentLogo"
        >
          {{ currentLogo ? 'View logo' : 'No logo uploaded' }}
        </vs-button>
        <vs-button
          v-if="currentLogo && !readonly"
          class="m-4"
          color="primary"
          type="border"
          @click="deleteLogoPopupActive=true"
        >
          Delete current logo
        </vs-button>
      </div>
      <vs-popup class="logo-popup" title="Current Logo" :active.sync="popupActive">
        <img :src="logoSrc" v-if="logoSrc">
      </vs-popup>
      <vs-popup class="delete-logo-popup" title="Delete Logo" :active.sync="deleteLogoPopupActive">
        <span>Are you sure you want to delete the current logo?</span>
        <div class="buttons mt-4 flex justify-between">
          <vs-button color="primary" type="border" @click="deleteLogo">
            Yes
          </vs-button>
          <vs-button color="primary" @click="deleteLogoPopupActive=false">
            No
          </vs-button>
        </div>
      </vs-popup>
    </card-page>
  </div>
</template>

<script>
import FormModelMixin from '@/components/mixins/FormModelMixin';
import CardPage from '../../../components/Views/CardPage';
import { validateFileType } from "@/validation/Vfg/resources";

export default {
  components: {
    CardPage
  },
  props: {
    value: {
      // type: Object,
      required: true,
    },
    currentLogo: {
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  mixins: [FormModelMixin],

  data() {
    return {
      popupActive: false,
      deleteLogoPopupActive: false,
      logoSrc: null,
      model: {
        logoFile: null,
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true
      },
      schema: {
        styleClasses: 'w-full',
        fields: [
          {
            type: "upload",
            inputType: "file",
            styleClasses: "w-full",
            label: "Logo",
            model: "logoFile",
            placeholder: "",
            files: true,
            disabled: this.readonly,
            validator: [validateFileType(['jpg','jpeg','png'])],
            onChanged: (model, schema, event, instance) => {
              this.model.logoFile = instance.$el.children[0].files[0];
            },
          },
        ]
      },
    };
  },

  async mounted() {
    if (this.currentLogo) {
      await this.loadLogo();
    }
  },

  methods: {
    async loadLogo() {
      const blob = await this.$api.companies.getLogo(this.$route.params.id);
      const base64data = await this.blobToData(blob.data);
      this.logoSrc = base64data;
    },
    blobToData(blob) {
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result)
        reader.readAsDataURL(blob)
      })
    },
    deleteLogo() {
      this.$emit('delete-logo');
      this.deleteLogoPopupActive = false;
    }
  }
};
</script>

<style lang="scss">
.logo-popup {
  img {
    width: 100%;
  }
}

 .logo-form-wrapper {
    display: flex;
    align-items: center;
 }
</style>
